export default "/static/media/night.64713477.css";